// Central config for external identity
export const WHATSAPP_NUMBER = "919672169073";
export const LOGO_URL = "https://customer-assets-rejwkqb3.emergentagent.net/job_90d02bde-b0f7-40b8-8020-d7046b1861a5/artifacts/05wcewgu_Bhoomiza%20final%20logo.png";
export const YOUTUBE_URL = "https://www.youtube.com/channel/UCKY9cJba4GNuunQCsSVhaJg";
export const INSTAGRAM_URL = "https://www.instagram.com/bhoomizaorganics";
export const YOUTUBE_QR = "https://customer-assets-m6fa6gv7.emergentagent.net/job_health-boost-43/artifacts/ddj7cic2_photo_2026-08-08_06-46-18.webp";
export const INSTAGRAM_QR = "https://customer-assets-m6fa6gv7.emergentagent.net/job_health-boost-43/artifacts/utoyh3ak_bhoomizaorganics_qr.webp";
export const HERO_IMAGE = "https://images.unsplash.com/photo-1704079698754-5e621edb610b?auto=format&fit=crop&w=1200&q=85";

export const openWhatsApp = (message) => {
  window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`, "_blank", "noopener,noreferrer");
};

export const buildCartMessage = (items, customer = null) => {
  const lines = ["NEW ORDER ENQUIRY – BHOOMIZA ORGANICS", ""];
  if (customer) {
    lines.push("CUSTOMER DETAILS");
    lines.push(`Full Name: ${customer.fullName}`);
    lines.push(`Mobile Number: ${customer.mobile}`);
    lines.push(`Delivery Address: ${customer.address}`);
    lines.push(`City: ${customer.city}`);
    lines.push(`State: ${customer.state}`);
    lines.push(`PIN Code: ${customer.pincode}`);
    if (customer.landmark) lines.push(`Landmark: ${customer.landmark}`);
    if (customer.altMobile) lines.push(`Alternate Mobile: ${customer.altMobile}`);
    if (customer.instructions) lines.push(`Delivery Instructions: ${customer.instructions}`);
    lines.push("");
  }
  lines.push("ORDER ITEMS");
  items.forEach((i) => {
    lines.push(`${i.name} – ${i.size} – Quantity: ${i.quantity}`);
  });
  lines.push("");
  lines.push("Please confirm product availability, prices, shipping charges, and the final payable amount with the customer on WhatsApp.");
  return lines.join("\n");
};

export const quickMessage = "Namaste Bhoomiza Organics, I'd like to know more about your products.";

export const buildEnquiryMessage = (productName, size) =>
  `Hello Bhoomiza Organics! I want to enquire about ${productName} (${size}). Please confirm the price and availability on WhatsApp.`;

